// extracted by mini-css-extract-plugin
export default {"cta":"yK-z","disabled":"zK-z"};